
<div class="row">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header" >
        <h3 class="card-title mb-4">{{pageHeading}}</h3>

        <div class="filter-wrapper field_space" *ngIf = "form">
          <form   [formGroup]="form" novalidate (ngSubmit)="saveImageData()">
            <div class="form-group col-12-div">
          

              <div class="form-group col-4-div">
                <label >First Name*</label>
                <input [pattern]="'^[a-zA-Z \-\']+'" class="form-control border-primary" (ngModelChange) = "onChangeName()"  formControlName="first_name" name="first_name" required>
                <div class="" *ngIf="form.controls.first_name.touched && !form.controls.first_name.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.first_name.errors.number">Numbers Are Not Allowed!</div>
                </div>

                <div class="" *ngIf="form.controls.first_name.touched && !form.controls.first_name.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.first_name.errors.required">First Name is required!</div>
                </div>
              </div>

              <div class="form-group col-4-div">
                <label >Last Name*</label>
                <input [pattern]="'^[a-zA-Z \-\']+'" class="form-control border-primary" (ngModelChange) = "onChangeName()"  formControlName="last_name" name="last_name" required>
                <div class="" *ngIf="form.controls.last_name.touched && !form.controls.last_name.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.last_name.errors.number">Numbers Are Not Allowed!</div>
                </div>
                <div class="" *ngIf="form.controls.last_name.touched && !form.controls.last_name.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.last_name.errors.required">Last Name is required!</div>
                </div>
              </div>

              <div class="form-group col-4-div">
                <label >Contact No.*</label>
                <input class="form-control border-primary" type="text" (keypress)="keyPressNumbers($event)" maxlength="10" minlength="10" formControlName="mobile_no" name="mobile_no" required>
                <div class="" *ngIf="form.controls.mobile_no.touched && !form.controls.mobile_no.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.mobile_no.errors.pattern">Invalid Mobile Number</div>
                </div>
                <div class="" *ngIf="form.controls.mobile_no.touched && !form.controls.mobile_no.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.mobile_no.errors.required">Contact Number is required!</div>
                </div>
              </div>


              <!-- <div class="form-group col-4-div">
                <label>Date Of Visit*</label>
                <input class="form-control border-primary" (ngModelChange) = "onChangeDate()" [owlDateTime]="dt2" [min]="minDate" [max]="maxDate" placeholder="Date" name="date_of_visit" formControlName="date_of_visit"
                       readonly>
                <span [owlDateTimeTrigger]="dt2" class="date-ico"><i class="fa fa-calendar"></i></span>
                <owl-date-time #dt2 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                
                <div class="" *ngIf="form.controls.date_of_visit.touched && !form.controls.date_of_visit.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.date_of_visit.errors.required">Date Of Visit is required!</div>
                </div>

              </div> -->

              <div class="form-group col-4-div">
                <label>Date Of Visit</label>
                <input class="form-control border-primary" formControlName="date_of_visit" readonly>
              </div>

              <input type="hidden" formControlName="darshan_type_id">

              <div class="form-group col-4-div">
                <label>Aarti Hall*</label>
                <select class="form-control border-primary" (change)="onHallChange()" formControlName="aarti_hall_id" name="aarti_hall_id" required>
                  <option [value]="''">select</option>
                  <option [value]="hall.id" *ngFor="let hall of allAartiHalls">{{hall.name}}</option>
                </select>
                <div class="" *ngIf="form.controls.aarti_hall_id.touched && !form.controls.aarti_hall_id.valid">
                  <div class="inaild_no" *ngIf="form.controls.aarti_hall_id.errors.required">Aarti Hall is required!</div>
                </div>
              </div>

              <div class="form-group col-4-div">
                <label>Row*</label>
                <select class="form-control border-primary" formControlName="aarti_hall_row_id" name="aarti_hall_row_id" required>
                  <option [value]="''">select</option>
                  <option [value]="row.id" *ngFor="let row of allHallRows">{{row.row_name}}</option>
                </select>
                <div class="" *ngIf="form.controls.aarti_hall_row_id.touched && !form.controls.aarti_hall_row_id.valid">
                  <div class="inaild_no" *ngIf="form.controls.aarti_hall_row_id.errors.required">Row is required!</div>
                </div>
              </div>

              <div class="form-group col-4-div">
                <label >No. Of People*</label>
              
                <select  class="form-control border-primary" (change)="onPersonCountChange()" name="no_of_persons" formControlName="no_of_persons">
                  <option [value]="''">select</option>
                  <option [value]="1">1</option>
                  <option [value]="2">2</option>
                  <option [value]="3">3</option>
                  <option [value]="4">4</option>
                  <option [value]="5">5</option>
                  <option [value]="6">6</option>
                  <option [value]="7">7</option>
                  <option [value]="8">8</option>
                  <option [value]="9">9</option>
                  <option [value]="10">10</option>
                  <option [value]="11">11</option>
                  <option [value]="12">12</option>
                  <option [value]="13">13</option>
                  <option [value]="14">14</option>
                  <option [value]="15">15</option>
                  <option [value]="16">16</option>
                  <option [value]="17">17</option>
                  <option [value]="18">18</option>
                  <option [value]="19">19</option>
                  <option [value]="20">20</option>
                  <option [value]="21">21</option>
                  <option [value]="22">22</option>
                  <option [value]="23">23</option>
                  <option [value]="24">24</option>
                  <option [value]="25">25</option>
                  <option [value]="26">26</option>
                  <option [value]="27">27</option>
                  <option [value]="28">28</option>
                  <option [value]="29">29</option>
                  <option [value]="30">30</option>
                  <option [value]="31">31</option>
                  <option [value]="32">32</option>
                  <option [value]="33">33</option>
                  <option [value]="34">34</option>
                  <option [value]="35">35</option>
                  <option [value]="36">36</option>
                  <option [value]="37">37</option>
                  <option [value]="38">38</option>
                  <option [value]="39">39</option>
                  <option [value]="40">40</option>
                  <option [value]="41">41</option>
                  <option [value]="42">42</option>
                  <option [value]="43">43</option>
                  <option [value]="44">44</option>
                  <option [value]="45">45</option>
                  <option [value]="46">46</option>
                  <option [value]="47">47</option>
                  <option [value]="48">48</option>
                  <option [value]="49">49</option>
                  <option [value]="50">50</option>
                 
                </select>
                <div class="" *ngIf="form.controls.no_of_persons.touched && !form.controls.no_of_persons.valid">
                  <div  class="inaild_no" *ngIf=" form.controls.no_of_persons.errors.required">No. Of People is required!</div>
                </div>
              </div>

            </div>

            <ng-container  formArrayName="visitors_basic_details">
              <div class="form-group col-12-div visitor_info" *ngFor="let visitor of form.controls['visitors_basic_details']['controls']; let i=index">
                <ng-container [formGroupName]="i">
                  <div class="form-group visitor_info_list">
                    <label >Name*</label>
                    <input [pattern]="'^[a-zA-Z \-\']+'" (ngModelChange) = "onChangePeopleName(i)" class="form-control border-primary"  formControlName="name" name="name" required [readonly]="i == 0">
                    <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.name.touched && !form.controls.visitors_basic_details.controls[i].controls.name.valid">
                      <div  class="inaild_no" *ngIf=" form.controls.visitors_basic_details.controls[i].controls.name.errors.pattern">Only Alphabet Allowed</div>
                    </div>
                    <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.name.touched && !form.controls.visitors_basic_details.controls[i].controls.name.valid">
                      <div  class="inaild_no" *ngIf=" form.controls.visitors_basic_details.controls[i].controls.name.errors.required">Name is required!</div>
                    </div>
                  </div>

                  <div class="form-group" style="width: 18%;">
                    <label >Age*</label>
                    <input class="form-control border-primary" type="number" formControlName="age" name="age" required>
                    <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.touched && !form.controls.visitors_basic_details.controls[i].controls.age.valid">
                      <div  class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.errors.required">Age is required!</div>
                    </div>
                    <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.touched && !form.controls.visitors_basic_details.controls[i].controls.age.valid">
                      <div  class="inaild_no" *ngIf="form.controls.visitors_basic_details.controls[i].controls.age.errors.max || form.controls.visitors_basic_details.controls[i].controls.age.errors.min">The age must be a number between 0 and 100</div>
                    </div>
                  </div>

                  <div class="form-group visitor_info_list">
                    <label >Gender*</label>
                    <select class="form-control border-primary"  name="gender" formControlName="gender">
                      <option [value]="''">select</option>
                      <option [value]="'Male'">Male</option>
                      <option [value]="'Female'">Female</option>
                      <option [value]="'Other'">Other</option>
                    </select>
                    <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.gender.touched && !form.controls.visitors_basic_details.controls[i].controls.gender.valid">
                      <div  class="inaild_no" *ngIf=" form.controls.visitors_basic_details.controls[i].controls.gender.errors.required">Gender is required!</div>
                    </div>
                  </div>

                  <ng-container >
                  <div class="form-group visitor_info_list">
                    <label >ID Proof Type*</label>
                    <select class="form-control border-primary" (change)="onIdProofTypeChange(i)"  name="id_proof_type_id" formControlName="id_proof_type_id">
                      <option [value]="''">select</option>
                      <option [value] ="type.id" *ngFor = "let type of id_proof_type_list">{{type.name}}</option>
                    </select>
                    <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.id_proof_type_id.touched && !form.controls.visitors_basic_details.controls[i].controls.id_proof_type_id.valid">
                      <div  class="inaild_no" *ngIf=" form.controls.visitors_basic_details.controls[i].controls.id_proof_type_id.errors.required">ID Proof Type is required!</div>
                    </div>
                  </div>

                  <div class="form-group visitor_info_list">
                    <label >ID Proof Number*</label>
                    <input class="form-control border-primary" (ngModelChange) = "onChangePeopleProofNumber(i)"  type="text"  formControlName="id_proof_number" name="id_proof_number" >
                    <div class="" *ngIf="form.controls.visitors_basic_details.controls[i].controls.id_proof_number.touched && !form.controls.visitors_basic_details.controls[i].controls.id_proof_number.valid">
                      <div  class="inaild_no" *ngIf=" form.controls.visitors_basic_details.controls[i].controls.id_proof_number.errors.required">ID Proof Number is required!</div>
                    </div>
                  </div>

                  <div class="form-group visitor_info_list" style="width: 142px;text-align: center;">
                    <button type="button" style="margin-top: 30px;float: left;" class="btn btn-inverse-primary btn-fw top-btn-head" (click) = "onClickCapturePhoto(i, findImageUrl(i) ? findImageUrl(i) : '')">{{findImageUrl(i) ? 'Edit' : 'Add'}} Photo</button><br>
                     <span>OR</span>
                     <br>
                     <div class="upload-btn-wrapper">
                      <button class="btn"
                        [ngClass]="findImageUrl(i) ? 'upload_file': ''">Upload A Photo</button>
                       <input type="file" name="document" accept="image/*" class="form_control"
                        (change)="onFileChange($event, i)" style="padding: 0 !important;" />
                      </div>
                  </div>


                  <div class="form-group visitor_info_close" style="width: 10%;" *ngIf = "findImageUrl(i)">
                    <img style="border: 1px solid #c1bdbd;" [src]="findImageUrl(i)" height="80" width="100" />
                  </div>
                  </ng-container>

                  <!-- <div class="form-group" style="width: 20%;">
                    <label >Visitor Type</label> <br>
                      <angular2-multiselect [data]="visitor_type"
                      formControlName="visitor_type_ids" name="visitor_type_ids"
                      [settings]="{singleSelection: false,
                              text:'Select' ,
                              enableSearchFilter: false,
                              labelKey:'name',
                              primaryKey:'id'}">
                    <c-badge>
                      <ng-template let-item="item">
                        <label>{{item.name}}</label>
                      </ng-template>
                    </c-badge>
                   </angular2-multiselect>
                  </div> -->
                  <div class="form-group visitor_info_close" style="width: 4%;" *ngIf = "i != 0">
                    <i class="fa fa-times remove-icon" aria-hidden="true" (click) = "remove(i)"></i>
                  </div>
                </ng-container>
              </div>
            </ng-container>

            ​<div class="button-wrap">
            <button  type="submit" [disabled]="!form.valid" class="btn btn-primary btn-fw">Submit</button>
            <button  type="button" class="btn btn-secondary btn-fw" (click)="close()">Close</button>
          </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>




